export enum DashboardTabState {
  TODO = 'To_Do',
  KPI_METRICS = 'Kpi_Metrics',
}
